import type { PropsWithChildren } from "react";
import type { Props } from "./FieldValuesContext";
import { FieldValuesContext } from "./FieldValuesContext";

export const FieldValuesContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <FieldValuesContext value={contextValue}>{children}</FieldValuesContext>
);
